<template>
  <div class="chartBox">
    <div class="bg-color-black">
      <div class="d-flex pt-2 pl-2 flexStart">
        <div style="color:#5cd9e8;margin-right: 10px;">
          <i class="el-icon-s-data"></i>
        </div>
        <div class="d-flex">
          <span class="fs-xl text mx-2">各专业分数段</span>
        </div>
      </div>
      <div v-if="!showFull" class="d-flex jc-center body-box scrollTableContainer"
           style="height:calc(100% - 30px);margin-top: 10px;overflow: hidden">
        <div class="tableHeaderContainer flexStart">
          <div style="width: 20px!important;"
               v-html="`#`"
          />
          <div class="header-item overText"
               v-for="(headerItem, i) in config.header"
               :key="i"
               v-html="headerItem"
          />
        </div>
        <div ref="#animBox" class="tableBodyContainer"
             @mouseenter="enterbox" @mouseleave="leavebox">
          <div
              class="row-item flexStart"
              v-for="(row, ri) in config.data"
              :key="ri">
            <div style="width: 20px!important;"
                 v-html="`${ri+1}`"
            />
            <div
                class="ceil overText"
                v-for="(ceil, ci) in row"
                :key="ci"
                v-html="ceil"/>

          </div>
        </div>

      </div>


      <div v-if="showFull" class="d-flex jc-center body-box scrollTableContainer" style="margin-top: 10px;">
        <dv-scroll-board :config="config"
                         style="width: 100%;height: 100%;overflow-y: hidden"/>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ScrollTable',
  data() {
    return {
      config: {
        type: Object,
        default: {
          header: [],
          data: [],
          rowNum: 7, //表格行数
          headerHeight: 35,
          headerBGC: "#0f1325", //表头
          oddRowBGC: "#0f1325", //奇数行
          evenRowBGC: "#171c33", //偶数行
          index: true,
          columnWidth: [45],
          align: ["center"]
        }
      },
      showFull: false,
      timer: null,
      stepTime: 50,
      set1: null,
      set2: null,
      set3: null,
    }
  },
  mounted() {
    let _this = this
    this.getData()
    clearInterval(this.timer)
    this.set1 = setTimeout(() => {
      _this.autoScroll('#animBox')
    }, 1000)
  },
  methods: {
    getData() {
      this.loading = true
      this.$http.post('/api/tj_major_score').then(res => {

        let dataArr = []
        let index = 0
        for (let item of res.data) {
          // console.log(108108,item)
          let objArr = []
          objArr.push(item.major_name)
          objArr.push(item.avg_score)
          objArr.push(item.max_score)
          objArr.push(item.min_score)
          dataArr.push(objArr);

        }


        this.config = {
          header: ['专业名称', '平均分', '最高分', '最低分'],
          data: dataArr,
          rowNum: 10, //表格行数
          headerHeight: 35,
          headerBGC: "#0f1325", //表头
          oddRowBGC: "#0f1325", //奇数行
          evenRowBGC: "#191e35", //偶数行
          index: true,
          columnWidth: [26, 125],
          align: ["center"],
          waitTime: 3000,
        }
        this.loading = false
      })
    },

    leavebox() {
      clearTimeout(this.set1)
      clearTimeout(this.set2)
      clearTimeout(this.set3)
      clearInterval(this.timer)
      this.autoScroll('#animBox', 10)
    },
    enterbox() {
      clearTimeout(this.set1)
      clearTimeout(this.set2)
      clearTimeout(this.set3)
      clearInterval(this.timer)
    },
    autoScroll(dom) {

      let _this = this
      let parentDom = this.$refs[dom]

      this.timer = setInterval(() => {
        //判断元素是否滚动到底部(可视高度+距离顶部=整个高度)
        if ((parentDom.scrollTop + parentDom.clientHeight) < parentDom.scrollHeight) {
          parentDom.scrollTop++ // 元素自增距离顶部
        } else {
          clearTimeout(this.set1)
          clearTimeout(this.set2)
          clearTimeout(this.set3)
          clearInterval(_this.timer)
          this.set2 = setTimeout(function () {
            parentDom.scrollTop = 0
          }, 1000)
          this.set3 = setTimeout(function () {
            _this.autoScroll('#animBox')
          }, 3000)
        }
      }, _this.stepTime)
    },
  },
  beforeRouteLeave(to, from, next) {
    next(vm => {
    })
    clearTimeout(this.set1)
    clearTimeout(this.set2)
    clearTimeout(this.set3)
    clearInterval(this.itimertl)
  },
  beforeDestroy() {
    clearTimeout(this.set1)
    clearTimeout(this.set2)
    clearTimeout(this.set3)
    clearInterval(this.timer)
  },
  destroyed() {
    clearTimeout(this.set1)
    clearTimeout(this.set2)
    clearTimeout(this.set3)
    clearInterval(this.timer)
    window.onresize = null;
  },
}
</script>
<style lang="less" type="text/less">
.dv-scroll-board {
  height: 100%;
  overflow: hidden;

  .rows {
    height: 100%;
    overflow: hidden;
  }
}

.scrollTableContainer {
  .dv-scroll-board {
    .header-item, .ceil {
      padding: 0;
    }
  }
}
</style>
<style scope lang="less" type="text/less">
.chartBox {
  padding: 0.2rem;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 0.0625rem;

  .bg-color-black {
    height: calc(100% - 30px);
    overflow: hidden;
    border-radius: 0.125rem;
  }

  .text {
    color: #c3cbde;
  }

  .body-box {
    height: 100%;
    border-radius: 0.125rem;
    overflow: hidden;
  }
}

.overText {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.scrollTableContainer {
  width: 100%;
  height: 100%;

  .tableHeaderContainer {
    width: 100%;
    height: calc(100% / 11);

    .header-item {
      flex: 1;
    }

    .header-item:nth-of-type(2) {
      flex: 0 0 205px;

    }

  }

  .tableBodyContainer {
    width: 100%;
    height: 100%;
    overflow-y: scroll;

    .row-item {
      width: 100%;
      height: calc(100% / 10);

      .ceil {
        flex: 1;
      }

      .ceil:nth-of-type(2) {
        flex: 0 0 205px;

      }
    }

    .row-item:nth-of-type(odd) {
      background-color: #191e35;
    }


  }
}

</style>

